"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementsProps = exports.TEXT_BOX = void 0;
const TEXT_BOX = exports.TEXT_BOX = 'text-box';
const elementsProps = exports.elementsProps = {
  headingProps: {
    align: 'center'
  }
};
